import React from "react";
import Typography from "@material-ui/core/Typography";
import tableicons from "../tableicons";
import MaterialTable, {MTableToolbar} from "material-table";
import {validacionTagResources, validacionWalmart} from "../endpoints";
import {Grid} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import SnackbarAlert from "../components/SnackbarAlert";
import DialogExportar from "../components/DialogExportar";
import SvgIcon from "@material-ui/core/SvgIcon";
class RecountSheets extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            cargando:false,
            valores:[],
            recontador: '',
            sup_ap:'',
            openSnack: false,
            severity: '',
            message: '',
            openExportar:false,
        }

    }

    getValidacionTagWalmart = () =>{
        validacionWalmart.getValidacionTagWalmart().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({valores:result.consulta,cargando:false})
        }).catch(error=> {
            console.log(error)
        });
    }
    getRecontadorSupAp = () =>{
        validacionWalmart.getRecontadorSupAp().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if (result!== null){
                this.setState({sup_ap:result.consulta.sup_ap, recontador:result.consulta.recontador})
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    }

    handleClose = () =>{
        this.setState({openExportar:false})
    }

    refrescarExportar =(estado,severity) =>{
        this.setState({openSnack:false, severity:null, message:null})
        if(estado){
            this.setState({
                openExportar: false,
                enviar:false,
                openSnack: true,
                message: estado,
                severity: severity})
        }
    }

    componentDidMount() {
        this.getValidacionTagWalmart()

        this.getRecontadorSupAp()
    }

    handleClick = () =>{
        this.setState({openSnack:false, severity: '', message:''})
        validacionWalmart.guardaSupRecontadorWalmart( this.state.sup_ap,this.state.recontador).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.setState({openSnack:true, severity: result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.setState({openSnack:true, severity: 'error', message:"Ha ocurrido un error inesperado"})
        });
    }

    guardarMotivoError = (motivo,rowData) =>{
        let tag = rowData.tag
        let error;
        if(motivo==='P'){
            error = 0.00
        }
        else{
            error = rowData.dif*100/rowData.cant_inv
        }
        this.setState({openSnack:false, severity: '', message:''})
        if (!rowData.mandatorio){
            validacionWalmart.guardarMotivoError(tag,motivo,error).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.setState({openSnack:true, severity: result.severity, message:result.message}, ()=>{
                        this.getValidacionTagWalmart()
                    })
                }
                else{
                    throw new Error('Something went wrong ...');
                }}).catch(error=> {
                console.log(error)
                this.setState({openSnack:true, severity: 'error', message:"Ha ocurrido un error inesperado"})
            });
        }
        else{
            validacionWalmart.guardarMotivoErrorMandatorios(tag,motivo).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.setState({openSnack:true, severity: result.severity, message:result.message}, ()=>{
                        this.getValidacionTagWalmart()
                    })
                }
                else{
                    throw new Error('Something went wrong ...');
                }}).catch(error=> {
                console.log(error)
                this.setState({openSnack:true, severity: 'error', message:"Ha ocurrido un error inesperado"})
            });
        }

    }
    editaCantidadValidada = (newValue, rowData) =>{
        this.setState({openSnack:false, severity: '', message:''})
        validacionTagResources.editarCantidadValidacionTag(rowData.tag, newValue, null).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.setState({openSnack:true, severity: result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.setState({openSnack:true, severity: 'error', message:"Ha ocurrido un error inesperado"})
            console.log(error)
        });
    }
    enviarDatosReportes =(nombre)=>{
        let params = ""
        this.setState({openExportar: true, reporte: nombre, params: params,openSnack:false})

    }

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>
                    Recount Sheets
                </Typography>
                <Grid container direction={"row"}>
                    <Grid item xs={3} style={{margin: '5px'}}>
                        <TextField variant="outlined" value={this.state.recontador} name="recontador" label="Nombre recontador" fullWidth onChange={this.handleChange}/>
                    </Grid>
                    <Grid item xs={3} style={{margin: '5px'}}>
                        <TextField variant="outlined" value={this.state.sup_ap} name="sup_ap" label="Nombre Walmart" fullWidth onChange={this.handleChange}/>
                    </Grid>
                    <Grid  item xs={2} style={{margin: '10px'}}>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={!this.state.recontador || !this.state.sup_ap}
                            onClick={this.handleClick}>
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
                <MaterialTable

                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                            nRowsSelected: "{0} registro(s) seleccionado(s)"
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        },
                        pagination:{
                            firstAriaLabel: 0,
                        },
                        header: {
                            actions: 'Acciones',
                            sizeActions:"large"
                        },
                    }}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense",
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                    }}

                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                    isLoading={this.state.cargando}
                    icons={tableicons}
                    title= ""
                    data={this.state.valores}
                    cellEditable={{
                        onCellEditApproved: (newValue, oldValue, rowData, columnDef) => {
                            return new Promise((resolve, reject) => {
                                if(columnDef.field === 'motivo'){
                                    const datos = this.state.valores
                                    const index = datos.indexOf(rowData)
                                    datos[index].motivo = newValue
                                    this.setState({valores: datos})
                                    setTimeout(()=>{
                                        resolve();
                                        this.guardarMotivoError(newValue,rowData)
                                    }, 1000);
                                }
                                else{
                                    if (oldValue >0 && rowData.cant_inv !==0) {
                                        const datos = this.state.valores
                                        const index = datos.indexOf(rowData)
                                        datos[index].cant_val = newValue
                                        this.setState({valores: datos})
                                        setTimeout(()=>{
                                            resolve();
                                            this.editaCantidadValidada(newValue,rowData)
                                        }, 1000);
                                    }
                                    else if (oldValue === 0 && newValue ===0) {
                                        setTimeout(resolve(), 1000);
                                    }
                                    else{
                                        this.setState({openSnack:false, severity: '', message:''})
                                        setTimeout(()=>{
                                            resolve();
                                            this.setState({openSnack:true, severity: 'error', message:'Tag sin reconteo'})
                                        }, 1000);
                                    }

                                }
                            });
                        },
                    }}
                    columns={[
                        { title: 'Cod. operador', field: 'usuario',
                            editable:"never",
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200,
                            }
                        },
                        { title: 'Tag', field: 'tag',
                            editable:"never",
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200,
                            }
                        },
                        { title: 'Conteo', field: 'cant_inv',
                            editable:"never",
                            cellStyle: {
                                width: 400,
                                maxWidth: 400,
                            },
                            headerStyle: {
                                width: 400,
                                maxWidth: 400
                            }
                        },
                        { title: 'Reconteo', field: 'cant_val',
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Diferencia', field: 'dif',
                            editable:"never",
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: '% Error', field: 'error', editable:"never",
                            render: rowData => (rowData.error).toFixed(2) ,
                            customFilterAndSearch: ((term, rowData) => (rowData.error).toFixed(2).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Razón', field: 'motivo',
                            lookup: {'--':'--' ,'P':'Preparación', 'S': 'Venta de sala','E':'Error al inventariar', 'U':'Bajo lo requerido'},
                        },

                    ]}
                    components={{
                        Toolbar: props => (
                            <div>
                                <MTableToolbar {...props} />
                                <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                                    <Grid item>
                                        <Button
                                            startIcon={ <SvgIcon>
                                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                            </SvgIcon>}
                                            variant="contained"
                                            color="primary"
                                            onClick={()=>{this.enviarDatosReportes("recount_sheets_1")}}>
                                            Form. Reconteo Vacío
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            startIcon={ <SvgIcon>
                                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                            </SvgIcon>}
                                            variant="contained"
                                            color="primary"
                                            onClick={()=>{this.enviarDatosReportes("recount_sheets_2")}}>
                                            Form. Reconteo error
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            startIcon={ <SvgIcon>
                                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                            </SvgIcon>}
                                            variant="contained"
                                            color="primary"
                                            onClick={()=>{this.enviarDatosReportes("recount_sheets_3")}}>
                                            Form. Reconteo error/motivo
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>)
                        }}
                    />
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.openExportar? <DialogExportar reporte={this.state.reporte} origen={'otro'} params={this.state.params} refrescar={this.refrescarExportar} handleClose={this.handleClose}/> : null}

            </div>
        )
    }
}
export default RecountSheets;